export default {
  // Hero section
  'hero.title': 'أدوات مؤقت احترافية على الإنترنت',
  'hero.subtitle': 'اختر أداة التوقيت المثالية لاحتياجاتك',

  // Tool cards
  'timer.title': 'المؤقت',
  'timer.description': 'مؤقت العد التنازلي للعمل والدراسة والحياة',
  'timer.longDescription': 'مؤقت العد التنازلي للإنتاجية والطبخ وإدارة الوقت',
  'timer.button': 'ابدأ المؤقت',

  'stopwatch.title': 'ساعة الإيقاف',
  'stopwatch.description': 'أداة توقيت عالية الدقة',
  'stopwatch.longDescription': 'ساعة إيقاف عالية الدقة للرياضة والتدريب والتوقيت الدقيق',
  'stopwatch.button': 'ابدأ ساعة الإيقاف',

  'worldclock.title': 'الساعة العالمية',
  'worldclock.description': 'اعرض المناطق الزمنية حول العالم',
  'worldclock.longDescription': 'عرض في الوقت الفعلي لأوقات المدن الرئيسية العالمية مع حسابات المناطق الزمنية الذكية',
  'worldclock.button': 'اعرض الساعة العالمية',

  // Features section
  'features.title': 'لماذا تختار timer.today؟',
  'features.reliable.title': 'موثوق ودقيق',
  'features.reliable.desc': 'توقيت بدقة ميلي ثانية مع موثوقية قائمة على المتصفح',
  'features.crossPlatform.title': 'متعدد المنصات',
  'features.crossPlatform.desc': 'يعمل بسلاسة على أجهزة سطح المكتب والأجهزة اللوحية والهواتف المحمولة',
  'features.smartNotifications.title': 'إشعارات ذكية',
  'features.smartNotifications.desc': 'تنبيهات صوتية وإشعارات سطح المكتب عند انتهاء الوقت',
  'features.easyToUse.title': 'سهل الاستخدام',
  'features.easyToUse.desc': 'واجهة نظيفة مع عناصر تحكم بديهية لجميع المستخدمين',

  // Keywords section
  'keywords.timer': 'timer countdown pomodoro focus work break',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
